module.exports = __webpack_public_path__ + "media/images/sp/specials/common/frequent/amazon-52586090920744fa82065a5acb77e292.jpg";